import { render } from "./shopLanding.vue?vue&type=template&id=f255bf64&scoped=true"
import script from "./shopLanding.vue?vue&type=script&lang=js"
export * from "./shopLanding.vue?vue&type=script&lang=js"

import "./shopLanding.vue?vue&type=style&index=0&id=f255bf64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f255bf64"]])

export default __exports__